export function PipelinePinIcon({ active }) {
  const stroke = active ? '#547A42' : '#A7C199'
  const fill   = active ? '#547A42' : 'white'
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_pipe_pin)">
        <path d="M0.5 11.5L4.24917 7.75083" stroke={stroke} fill="none" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.8416 3.79502L7.85224 6.78444C8.18443 8.02842 7.86256 9.41077 6.88661 10.3867L1.61328 5.11337C2.58918 4.13742 3.97153 3.81555 5.21554 4.14777L8.20496 1.15834" stroke={stroke} fill={fill} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.54688 0.4981L11.5019 4.45312" stroke={stroke} fill="none" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_pipe_pin">
          <rect width="12" height="12" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
